import TimeActivityCollection from '@spa/apps/trustup-pro-planning-js/collections/TimeActivityCollection';

export default class WorksiteTimeActivityCollection extends TimeActivityCollection
{

    constructor(items, worksite)
    {
        super(items);

        this.worksite = worksite;
    }

    itemShouldBeInCollection(activity)
    {
        console.log('Checking if item should be in collection', this, activity, this.worksite, activity.hasWorksite(this.worksite.uuid));
        return activity.hasWorksite(this.worksite.uuid);
    }

}